<template>
  <el-breadcrumb style="color: #fff">
    <p style="float: left;color: #000" class="bread_crumb_item">{{$t('current_page')}}</p>
    <el-breadcrumb-item><a href="/" class="bread_crumb_item" style="margin-left: 8px;">{{$t('home')}}</a></el-breadcrumb-item>
    <el-breadcrumb-item class="bread_crumb_item">{{currentFirstMenu}}</el-breadcrumb-item>
    <el-breadcrumb-item class="bread_crumb_item">{{currentPath}}</el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script>
    export default {
        name: 'BreadCrumb',
        data() {
            return {
                currentPath: this.$t('company_introductions'),
                currentFirstMenu: "",
            };
        },
        methods: {
          judgeCurrentPath(){
              let current_route = this.$route.name
              switch (current_route) {
                  case 'CompanyIntroductions':
                      this.currentPath = this.$t('company_introductions')
                      this.currentFirstMenu = this.$t('about_us')
                      break;
                  case 'CompanySystem':
                      this.currentPath = this.$t('company_system')
                      this.currentFirstMenu = this.$t('about_us')
                      break;
                  case 'Organization':
                      this.currentPath = this.$t('company_organization')
                      this.currentFirstMenu = this.$t('about_us')
                      break;
                  case 'CompanyCulture':
                      this.currentPath = this.$t('company_culture')
                      this.currentFirstMenu = this.$t('about_us')
                      break;
                  case 'ContactUs':
                      this.currentPath = this.$t('contact_us')
                      this.currentFirstMenu = this.$t('about_us')
                      break;
                  case 'AgencyBusiness':
                      this.currentPath = this.$t('institutional_business')
                      this.currentFirstMenu = this.$t('business_introductions')
                      break;
                  case 'PersonalBusiness':
                      this.currentPath = this.$t('personal_business')
                      this.currentFirstMenu = this.$t('business_introductions')
                      break;
              }
          }
        },
        mounted() {
            this.judgeCurrentPath()
        }
    }
</script>

<style scoped>
    .bread_crumb_item{
        font-size: 16px;
    }
    a{
        font-size: 16px;
    }
    .el-breadcrumb__separator{
        color: #fff;
    }

</style>